import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AplicacionService} from 'src/app/_module/procesadora/aplicacion-datos/aplicacion/aplicacion.service';
import {MatDialog} from '@angular/material/dialog';
import {Listas} from 'src/app/_helpers/clases/listas';
import {Aplicacion} from 'src/app/_models/aplicacion';
import {PageHeaderDataService} from 'src/app/shared/services/page-header-data.service';
import {PageHeaderData} from 'src/app/shared/components/forms-header/page-header-data';


/**
 * Listado de las aplicaciones utilizadas por el usuario.
 * @author Alejandro Planas
 */
@Component({
  selector: 'app-aplicacion-list',
  templateUrl: './aplicacion-list.component.html',
  styleUrls: ['./aplicacion-list.component.scss'],
})
export class AplicacionListComponent extends Listas<Aplicacion> implements OnInit {
  tableColumns = [{name: 'Nombre', val: 'nombre'}, {name: 'id de App', val: 'app_id'},
    {name: 'Verifiacion Automatica', val: 'verificacion_automatica', cellOptions: {tipo: 'boolean'}}];

  constructor(
    public router: Router,
    public service: AplicacionService,
    public dialog: MatDialog,
    private headerDataService: PageHeaderDataService
  ) {
    super(router, 'procesadora/aplicacion', service, dialog);
  }

  ngOnInit(): void {
    this.headerDataService.setHeaderData(new PageHeaderData('Aplicaciones', this.rutaPadre + '/registrar',
      false, true));
  }


}
